// Loop Card Product Slider
var $carouselLoopCard = $('.loop-card-product').flickity({
  lazyLoad: 2,
  draggable: true,
  wrapAround: true,
  cellAlign: 'center',
  initialIndex: 0,  
  freeScroll: true, 
  pageDots: false,
  prevNextButtons: true,
  groupCells: true,
  fade: true // Enable fade transition
});   

var $carouseljournal = $('.journal-slider').flickity({
  lazyLoad: 2,
  draggable: true,
  wrapAround: true,
  cellAlign: 'center',
  initialIndex: 2,     
  freeScroll: true, 
  pageDots: true,
  prevNextButtons: true,
  groupCells: true,
  fade: true // Enable fade transition
});        

  
// Theme Slider Flickity Initialization
var $carouselThemeSliderF = $('.theme-slider-f').flickity({
    lazyLoad: 2,
    draggable: true,
    initialIndex: 2, // Start with the third item
    wrapAround: true,
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: false 
});
  
// Access Flickity instance
var flktyThemeSliderF = $carouselThemeSliderF.data('flickity');

// Function to update the progress bar
function updateProgressBarThemeSlider() {
  var cellCount = flktyThemeSliderF.slides.length; // Total number of cells
  var initialIndex = flktyThemeSliderF.selectedIndex; // Index of the initially selected cell
  var progress = initialIndex / (cellCount - 1); // Calculate progress based on the initial index
  progress = Math.max(0, Math.min(1, progress));
  $('.progress-bar').width(progress * 100 + '%');
}
  
// Update progress bar after a short delay to ensure Flickity is initialized
setTimeout(updateProgressBarThemeSlider, 100);
  
// Update progress bar on scroll event
$carouselThemeSliderF.on('scroll.flickity', function(event, progress) {
  progress = Math.max(0, Math.min(1, progress));
  $('.progress-bar').width(progress * 100 + '%');
});
  
 


// Theme Slider One Initialization
var $carouselThemeSliderOne = $('.theme-slider-one').flickity({
  lazyLoad: 2,
  draggable: true,
  wrapAround: true,
  cellAlign: 'center',
  initialIndex: 0,  
  freeScroll: true, 
  pageDots: false,
  prevNextButtons: false,
  fade: true // Enable fade transition
});
 
$(document).ready(function() {
  // Get Flickity instance
  var $carousel = $('.theme-slider-one').flickity();
  var flkty = $carousel.data('flickity');
 
  // Bind custom next button
  $('.custom-next').on('click', function() {
    $carousel.flickity('next');
  });  
});
  
// Shop by Style Flickity
var elemShopByStyle = document.querySelector('.shop-by-style-inner');
var flktyShopByStyle = new Flickity(elemShopByStyle, {
  lazyLoad: 2,
  draggable: true,
  wrapAround: true,
  cellAlign: 'center',
  initialIndex: 0,  
  freeScroll: true,  
  prevNextButtons: true,
  contain: true,
  pageDots: false,
  fade: true // Enable fade effect
});




// Conversion functions
function cmToInches(cm) {
  return (cm / 2.54).toFixed(2);
}

function feetToInches(feet) {
  return (feet * 12).toFixed(2);
}

function sqFeetToSqMeters(sqFeet) {
  return (sqFeet * 0.092903).toFixed(2);
}

function inchesToCm(inches) {
  return (inches * 2.54).toFixed(2);
}

function feetToCm(feet) {
  return (feet * 30.48).toFixed(2);
}

function updateDimensions() {
  $('.cm-feet--in').each(function() {
      var text = $(this).text();
      console.log('Updating text:', text); // Debugging line

      // Store the original values in data attributes if not already stored
      if (!$(this).data('original')) {
          $(this).data('original', text);  // Store original text (inches/feet)
      }

      // Check for inches values and convert to centimeters
      if (text.includes('in.')) {
          var inchesValue = parseFloat(text.match(/(\d+(\.\d+)?)\s*in/)[1]);
          var cmValue = inchesToCm(inchesValue);
          $(this).html(text.replace(/(\d+(\.\d+)?)\s*in/, cmValue + ' cm'));
      }
      // Check for feet values and convert to centimeters
      else if (text.includes('ft') || text.includes('feet')) {
          var feetValue = parseFloat(text.match(/(\d+(\.\d+)?)\s*(ft|feet)/)[1]);
          var cmValue = feetToCm(feetValue);
          $(this).html(text.replace(/(\d+(\.\d+)?)\s*(ft|feet)/, cmValue + ' cm'));
      }
  });

  $('.cm-feet--mter').each(function() {
      var text = $(this).text();
      console.log('Updating text (sq. meters):', text); // Debugging line

      // Store the original values in data attributes if not already stored
      if (!$(this).data('original')) {
          $(this).data('original', text);  // Store original text (sq ft)
      }

      // Check for sq. ft values and convert to sq. meters
      if (text.includes('sq. ft')) {
          var sqFeetValue = parseFloat(text.match(/(\d+(\.\d+)?)\s*sq\.?\s*ft/)[1]);
          var sqMetersValue = sqFeetToSqMeters(sqFeetValue);
          $(this).html(text.replace(/(\d+(\.\d+)?)\s*sq\.?\s*ft/, sqMetersValue + ' sq. m'));
      }
  });
}

function resetToOriginal() {
  $('.cm-feet--in').each(function() {
      var originalText = $(this).data('original'); // Get the original text from the data attribute
      if (originalText) {
          $(this).html(originalText); // Reset to original inches/feet values
      }
  });

  $('.cm-feet--mter').each(function() {
      var originalText = $(this).data('original'); // Get the original text from the data attribute
      if (originalText) {
          $(this).html(originalText); // Reset to original sq. ft values
      }
  });
}

function handleConversion() {
  if ($('#toggleSwitch').is(':checked')) {
      // Switch is ON: Convert values to centimeters
      updateDimensions();
  } else {
      // Switch is OFF: Reset values to original (inches/feet)
      resetToOriginal();
  }
}

$('.variant-wrapper.size .variant-input').change(function() {
  // Update dimensions when variant input changes
  updateDimensions();
});

$('#toggleSwitch').change(function() {
  if ($(this).is(':checked')) {
      // Show "Switch is ON" text and centimeters text
      $('#switchTextOn').show();
      $('#switchTextOff').hide();
      $('#inchView').hide();
      $('#cmView').show();
  } else {
      // Show "Switch is OFF" text and inches text
      $('#switchTextOn').hide();
      $('#switchTextOff').show();
      $('#inchView').show();
      $('#cmView').hide();
  }

  // Handle conversion based on switch status
  handleConversion();
});

// Initial conversion based on the initial state of the switch
handleConversion();

$(document).ready(function() {
  $('.socialmedia-pop').click(function() {
      $(this).toggleClass('show-social');
  });
});

$(document).ready(function() {
  $('#mobile-size').on('click', function() {
      $('tool-tip-trigger').trigger('click');
  });
});

 
$(document).ready(function(){
  $('#sidebarToggleBtnx, .clode-side-bar-filter').click(function(){
      $('#sidebarContainerx').toggleClass('is-visible');
      $(this).toggleClass('is-active');

 
  });
});


$(document).ready(function() {
  $('#CollectionAjaxContent .collection__description a').attr('target', '_blank');
});


$(document).ready(function() {
  // For input focus
  $('.contact-p-row .concta-form-filed input').each(function() {
    if ($(this).val()) {
      $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').addClass('focused');
    }
  }).focus(function() {
    $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').addClass('focused');
  }).blur(function() {
    if (!$(this).val()) {
      $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').removeClass('focused');
    }
  });

  // For textarea focus
  $('.contact-p-row .concta-form-filed textarea').each(function() {
    if ($(this).val()) {
      $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').addClass('focused-text');
    }
  }).focus(function() {
    $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').addClass('focused-text');
  }).blur(function() {
    if (!$(this).val()) {
      $('.contact-p-row .concta-form-filed label[for="' + $(this).attr('id') + '"]').removeClass('focused-text');
    }
  });
});











$(document).ready(function() {
  // On click of a menu item with submenu
  $('.filter-has-submenu > a').click(function(e) {
    e.preventDefault(); // Prevent the default behavior of the anchor tag

    var $parentMenuItem = $(this).parent('.filter-menu-item');
    var $submenu = $parentMenuItem.find('.filter-submenu');

    // Check if this submenu is already open
    if ($parentMenuItem.hasClass('open')) {
      // If open, close the submenu
      $submenu.css('height', 0); // Set height to 0
      $parentMenuItem.removeClass('open');
    } else {
      // If not open, close any other open submenus
      $('.filter-menu-item').removeClass('open');
      $('.filter-submenu').css('height', 0); // Set all others to height 0

      // Open the clicked submenu
      var submenuHeight = $submenu.get(0).scrollHeight; // Get the full height of the submenu
      $submenu.css('height', submenuHeight + 'px'); // Set the height to its content height
      $parentMenuItem.addClass('open');
    }
  });
});



$(document).on('click', '.mobile-slide-btn-right', function() {
  $('.shop-by-style-inner .flickity-button.flickity-prev-next-button.flickity-next').trigger('click');
});

$(document).on('click', '.mobile-slide-btn-left', function() {
  $('.shop-by-style-inner .flickity-button.flickity-prev-next-button.flickity-previous').trigger('click');
});

// Collection List Show More/Less Logic
setTimeout(function() {
  $('.shop-by-collection-list li:lt(6)').show();
  $('.shop-by-collection-list .less').hide();
  $('.shop-by-collection-list .more').click(function () {
    var parent = $(this).parent('.shop-by-collection-list');
    var ul = parent.children('ul');
    parent.children('.less').show();
    var items = ul.children('li').length;
    var shown = ul.children('li:visible').length;
    ul.children('li:lt('+items+')').fadeIn(1200);;
    $(this).hide();
  }); 
  $('.shop-by-collection-list .less').click(function () {
    var parent = $(this).parent('.shop-by-collection-list');
    parent.children('ul').children('li').not(':lt(6)').fadeOut(800);
    parent.children('.more').show();
    parent.children('.less').hide();
  });
});

// Product Card Hover Effects
$(document).ready(function() {
  $('.product-card__figure').mouseover(function() {
    $(this).find('.collection_img_carousel').addClass('is-hovered');
  });

  $('.product-card__figure').mouseleave(function() {
    $(this).find('.collection_img_carousel').removeClass('is-hovered');
  });
});

 
// Function to update the content of the selected slide
function updateSlideContentShopByStyle() {
  var selectedIndex = flktyShopByStyle.selectedIndex;
  var selectedElement = flktyShopByStyle.selectedElement;
  var nextIndex = (selectedIndex + 1) % flktyShopByStyle.cells.length;
  var nextElement = flktyShopByStyle.cells[nextIndex].element;

  // Retrieve the h2 text from the next slide
  var nextHeading = nextElement.querySelector('h2').innerText;

  // Find or create next-slide-content element
  var nextContentDiv = selectedElement.querySelector('.next-slide-content');
  if (!nextContentDiv) {
    nextContentDiv = document.createElement('h2');
    nextContentDiv.className = 'next-slide-content';
    // Append nextContentDiv to .shop-by-style-left-cont
    var container = selectedElement.querySelector('.shop-by-style-title-slide');
    if (container) {
      container.appendChild(nextContentDiv);
    }
  }

  // Update the content of the next-slide-content
  nextContentDiv.innerText = nextHeading;

  // Ensure next-slide-content is positioned after current-titles
  var currentTitles = selectedElement.querySelector('.shop-by-style-title-slide .current-titles');
  if (currentTitles) {
    container.insertBefore(nextContentDiv, currentTitles.nextSibling);
  } else {
    // If current-titles is not found, just append it to the end of the container
    container.appendChild(nextContentDiv);
  }
}

// Update content immediately after Flickity is initialized
flktyShopByStyle.on('ready', updateSlideContentShopByStyle);

// Update content whenever a new slide is selected
flktyShopByStyle.on('select', updateSlideContentShopByStyle);

// Manually trigger the content update after initializing Flickity
// updateSlideContentShopByStyle();

  
